import { IconProps } from 'src/utils/icon';

const ArrowLeftIcon: React.FC<IconProps> = ({ size = 1, fill = '#2C2A29' }) => (
  <svg
    style={{ fontSize: `${size}rem` }}
    viewBox="0 0 19 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.467 0.7462L7.29935 1.55117C7.50093 1.74612 7.49762 2.06321 7.29201 2.25418L3.8687 5.43363H18.4911C18.7721 5.43363 19 5.65401 19 5.92582V7.07425C19 7.34607 18.7721 7.56644 18.4911 7.56644H3.8687L7.29197 10.7459C7.49762 10.9369 7.50093 11.254 7.29931 11.4489L6.46696 12.2539C6.26822 12.4461 5.94598 12.4461 5.7472 12.2539L0.157513 6.84805C-0.0412254 6.65585 -0.0412254 6.34422 0.157513 6.15198L5.74729 0.7462C5.94602 0.554001 6.26826 0.554001 6.467 0.7462Z"
      fill={fill}
    />
  </svg>
);

export default ArrowLeftIcon;
